import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { VendedorRequest } from '../../requests/pessoa/vendedor.request';
import { VendedorResponsavelEmMassaRequest } from '../../requests/pessoa/vendedor-responsavel-em-massa.request';
import { GetAllVendedorResponse } from '../../responses/pessoa/get-all-vendedor.response';
import { VendedorResponse } from '../../responses/pessoa/vendedor.response';
import { GetVendedorHierarquiaResponse } from '../../responses/pessoa/get-vendedor-hierarquia.response';
import { GetVendedorHierarquiaFlatResponse } from '../../responses/pessoa/get-vendedor-hierarquia-flat.response';
import { VendedorResponsavelEmMassaResponse } from '../../responses/pessoa/vendedor-responsavel-em-massa.response';

@Injectable({
  providedIn: 'root',
})
export class VendedorService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  // Controller: [HttpPost("getAll")] public IActionResult GetAll([FromBody] VendedorRequest filter, int paginaAtual = 0)
  public getAll(searchText: string, paginaAtual: number = 0): Observable<GetAllVendedorResponse> {
    let uri: string = `Vendedor/getAll?paginaAtual=${paginaAtual}`;

    if (searchText) {
      uri += `&searchText=${searchText}`;
    }

    return this.httpClient
      .get<GetAllVendedorResponse>(
        environment.urlApiPessoa + uri,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpGet("idVendedor/{idVendedor}")]
  public ObterPorId(idVendedor: number): Observable<VendedorResponse> {
    return this.httpClient
      .get<VendedorResponse>(
        environment.urlApiPessoa + `Vendedor/idVendedor/${idVendedor}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpPost]
  public Incluir(vendedorRequest: VendedorRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(
        environment.urlApiPessoa + `Vendedor`,
        vendedorRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpPut("idVendedor/{idVendedor}")]
  public Alterar(idVendedor: number, vendedorRequest: VendedorRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiPessoa + `Vendedor/idVendedor/${idVendedor}`,
        vendedorRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpPut]
  public excluirMultiplos(listIdVendedor: number[]): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiPessoa + `Vendedor/deleteRange`,
        listIdVendedor,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpGet("hierarquiaFlat")]
  public getHierarquiaFlat(): Observable<GetVendedorHierarquiaFlatResponse> {
    return this.httpClient
      .get<GetVendedorHierarquiaFlatResponse>(
        environment.urlApiPessoa + `Vendedor/hierarquiaFlat`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpGet("idVendedor/{idVendedor}/hierarquia")]
  public getHierarquia(idVendedor: number): Observable<GetVendedorHierarquiaResponse> {
    return this.httpClient
      .get<GetVendedorHierarquiaResponse>(
        environment.urlApiPessoa + `Vendedor/idVendedor/${idVendedor}/hierarquia`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpPut("alterarVendedorResponsavelEmMassa")]
  public alterarVendedorResponsavelEmMassa(request: VendedorResponsavelEmMassaRequest): Observable<VendedorResponsavelEmMassaResponse> {
    return this.httpClient
      .put<VendedorResponsavelEmMassaResponse>(
        environment.urlApiPessoa + `Vendedor/alterarVendedorResponsavelEmMassa`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}